import { Flex } from "@chakra-ui/react";
import CInput from "../CInput/CInput";
import CSelect from "../CSelect";
import { GridDepthExampleType } from "src/api/types";

export default function CommonGridDepthForm(props: { styles: any }) {
  const { styles } = props;

  return (
    <>
      <Flex alignItems="center" gap={2} mt={4}>
        <CInput classname={styles.inputField} label="策略名称" name="strategyName" />
      </Flex>
      <Flex>
        <CInput classname={styles.inputField} label="最低价" name="minPrice10" type="number" />
      </Flex>
      <Flex>
        <CInput classname={styles.inputField} label="最高价" name="maxPrice10" type="number" />
      </Flex>
      <Flex>
        <CInput
          classname={styles.inputField}
          label="总金额"
          name="totalAmount10"
          type="number"
          description="总金额（U）"
        />
      </Flex>

      <Flex>
        <CInput classname={styles.inputField} label="分几层" name="layerNum10" type="number" />
      </Flex>
    </>
  );
}
